import SalesChannelPrice from './sales-channel-price';
import { TravellerCategory } from '../../../../models/traveller-category.enum';
import { ProductInstanceType } from '../../../../models/product-instance-type.enum';

export default class SingleTicketGrouping {
  public salesChannels: SalesChannelPrice[];
  public ticketName: string;
  public travellerCategory: TravellerCategory;
  public validity: number;
  public productInstanceType: ProductInstanceType;

  constructor(name: string, travellerCategory: TravellerCategory, validity: number, productInstanceType: ProductInstanceType) {
    this.ticketName = name;
    this.travellerCategory = travellerCategory;
    this.validity = validity;
    this.productInstanceType = productInstanceType;
    this.salesChannels = [];
  }

  public addChannel(channel: SalesChannelPrice) {
    this.salesChannels.push(channel);
  }
}
